import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BASENAME } from "../../../utils/basename";

const SelectLanguage = (props) => {
  const siteParams = useSelector((state) => state.siteParams);
  const currentPage = useSelector((state) => state.currentPage);

  useEffect(() => {
    //console.log(siteParams);
    //console.log("siteparams");
  }, []);

  const array_languages = {
    IT: siteParams.sitoDominio_it,
    EN: siteParams.sitoDominio_en,
    FR: siteParams.sitoDominio_fr,
    DE: siteParams.sitoDominio_de,
  };

  const onClickLanguage = (event, idlanguageli) => {
    console.log("clickked " + idlanguageli);
    event.preventDefault();
    const elementToShow = document.getElementById("languagelist");
    elementToShow.classList.toggle("hidden");
  };

  const langsList = Object.keys(array_languages).map((language, key) => {
    return (
      language !== siteParams.current_language.toUpperCase() && (
        <option
          key={language}
          value={language + "_" + array_languages[language] + "/"}
        >
          {language}
        </option>
      )
    );
  });

  const langSelected = Object.keys(array_languages).map((language, key) => {
    return (
      language === siteParams.current_language.toUpperCase() && (
        <option key={language}>{language}</option>
      )
    );
  });

  const langsListli = Object.keys(array_languages).map((language, key) => {
    return (
      language !== siteParams.current_language.toUpperCase() && (
        <li
          id={"idlang" + language}
          onClick={(event) =>
            onChangeLanguage(
              event,
              language + "_" + array_languages[language] + "/"
            )
          }
          className="cursor-pointer flex items-center justify-start lilanguage"
          key={language}
          data-alternate={language + "_" + array_languages[language] + "/"}
        >
          <img
            src={`${BASENAME}/images/flags/${language.toLowerCase()}.svg`}
            width="45"
            height="45"
            className="flex-start px-3 py-2"
            alt={language}
          />
          <span className="valuelilang">{language}</span>
        </li>
      )
    );
  });

  const langSelectedli = Object.keys(array_languages).map((language, key) => {
    return (
      language === siteParams.current_language.toUpperCase() && (
        <li
          id={"idlang" + language}
          onClick={(event) => onClickLanguage(event, "idlang" + language)}
          className="cursor-pointer flex items-center justify-start lilanguage selectedlang pr-5"
          key={language}
          data-alternate={language + "_" + array_languages[language] + "/"}
        >
          <img
            src={`${BASENAME}/images/flags/${language.toLowerCase()}.svg`}
            width="45"
            height="45"
            className="flex-start px-3 py-2"
            alt={language}
          />
          <span className="valuelilang">{language}</span>
        </li>
      )
    );
  });

  const onChangeLanguage = (event, languageid = "") => {
    let tosplit = languageid;
    // se ho l'alternate della pagina punto a quello altrimenti alla homepage
    const alternate_it = currentPage?.pageLinkSeo_it;
    const alternate_en = currentPage?.pageLinkSeo_en;
    const alternate_fr = currentPage?.pageLinkSeo_fr;
    const alternate_de = currentPage?.pageLinkSeo_de;
    const langSelected = tosplit.split("_")[0];

    if (langSelected === "IT") {
      if (alternate_it) {
        window.location = array_languages["IT"] + alternate_it;
      } else {
        window.location = array_languages["IT"];
      }
    }

    if (langSelected === "EN") {
      if (alternate_en) {
        window.location = array_languages["EN"] + alternate_en;
      } else {
        window.location = array_languages["EN"];
      }
    }

    if (langSelected === "FR") {
      if (alternate_fr) {
        window.location = array_languages["FR"] + alternate_fr;
      } else {
        window.location = array_languages["FR"];
      }
    }

    if (langSelected === "DE") {
      if (alternate_de) {
        window.location = array_languages["DE"] + alternate_de;
      } else {
        window.location = array_languages["DE"];
      }
    }
  };

  return (
    <div className="customSelect">
      <ul className="list-none relative">
        {langSelectedli}
        <li
          id="languagelist"
          className="languagelist absolute z-10 w-full bg-white hidden"
        >
          <ul>{langsListli}</ul>
        </li>
      </ul>
    </div>
  );
};

export default SelectLanguage;
